import React, { useState, useRef } from "react";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import axios from "axios";
import { validaSoloNumero } from "../../util/varios";
import useTableFijo from "../useTableFijo";
import CatalogoContable from "../../catalogos/catalogoContable";
import { Dimmer } from "../spinner";
import { Input, SearchInput } from "../../ui/inputs/Input";
import {
  DangerButton,
  PrimaryButton,
  SuccessButton,
} from "../../ui/buttons/Button";

const headCells = [
  {
    id: "idtipoproducto",
    label: "",
    width: "30px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },

  {
    id: "idtipoproducto",
    label: "PUC",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "DESCRIPCION",
    width: "440px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaVincularCuenta(props) {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  let inputElement = document.getElementById("codigocuenta");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const btnCancela = useRef();
  const btnAcepta = useRef();
  const txtId = useRef();
//   const txtDescripcion = useRef();
//   const cmbTipo = useRef();
  const txtDeducible = useRef();
  const txtOtroPorcen = useRef();
  const txtCuentaContable = useRef();

  const [operacion, setOperacion] = useState(0);

  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [visibleId, setVisibleId] = useState("visible");
  const [visibleOtro, setVisibleOtro] = useState("collapse");
  const [visibleISLR, setVisibleISLR] = useState("hidden");
  const [tituloHeader, setTituloHeader] = useState(
    "Gestionar Vinculación de Cuentas."
  );

  const [habilitado, setHabilitado] = useState(true);

  const [records, setRecords] = useState([]);
  const [records2, setRecords2] = useState([]);

  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [activate2, setActivate2] = useState(false);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [mostrar, setMostrar] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true,
  });
  const [values, setValues] = useState({
    idplancuenta: "",
    codigocuenta: "",
    descripcion: "",
    idefiscal: "",
    cargable: "",
    naturaleza: "",
    tipopago: "",
    tiporecurso: "",
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting } = useTableFijo(
    records,
    headCells,
    filterFn
  );

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.puc.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });

    if (mensajesino.titulo === "Confirmación.") {
      procesarRegistro();
    }
  };
  const [habilitadoNU, setHabilitadoNU] = useState(true);

  const blanquear = () => {
    txtCuentaContable.current.value = "";
    txtId.current.setAttribute("disabled", true);
    setOperacion(0);
    setRecords([]);
    setRecords2([]);
    setTituloHeader("Gestionar Vinculación de Cuentas.");
    setVisibleISLR("hidden");
    setVisibleOtro("collapse");
    setVisibleBtn("visible");
    setVisibleId("visible");

    setValues({
      idplancuenta: "",
      codigocuenta: "",
      descripcion: "",
      idefiscal: "",
      cargable: "",
      naturaleza: "",
      tipopago: "",
      tiporecurso: "",
    });
    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true,
    });

    txtId.current.value = "";
    // txtDescripcion.current.value = "";

    // cmbTipo.current.value = "";

    setActivate(false);
    setHabilitado(true);
    setHabilitadoNU(true);
  };

  const procesarRegistro = () => {
    setActivate(true);
    

    let endpoint = `${op.conexion}/api/contabilidadfis/vincularctaspresu`;

    let codig = txtCuentaContable.current.value.trim().replace("-", "");

    let body = {
      idcuenta: txtId.current.value,
      idefiscal: idefiscal,
      array: records2,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Venculación Exitosa",
            icono: "exito",
          });

          setActivate(false);
          blanquear();
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarPuc = () => {
    let campos = "*";
    let nomtab = "puc";
    let nomid = "idefiscal";
    let orden = "puc";

    let endpoint = `${op.conexion}/api/consulta/modeliorder?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${idefiscal}&orden=${orden}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          let dd = [];

          if (response.data !== "") {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].puc.substring(5,7) !== "00"){
                if (response.data[i].idcuentadebe !== 0 && parseInt(response.data[i].idcuentadebe) === parseInt(txtId.current.value.trim())){
                  dd.push({ ...response.data[i], ["checked"]: 1 });
                } else {
                  dd.push({ ...response.data[i], ["checked"]: 0 });
                }
              }
              // dd.push({ ...response.data[i], ["checked"]: 0 });
            }
            setRecords(dd);
            console.log(dd);

            setActivate(false);
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            // txtDescripcion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarCuenta = (id) => {
    setMostrar(false);
    let campos = "*";
    let nomtab = "cuentacontable";
    let nomid = "idcuentacontable";
    let nomtab2 = "plancuenta";
    let nomid3 = "idplancuenta";

    let endpoint = `${
      op.conexion
    }/api/consulta/modeli10?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${parseInt(
      id
    )}&nomtab2=${nomtab2}&nomid3=${nomid3}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            txtId.current.value = response.data.idcuentacontable;
            txtCuentaContable.current.value = response.data.descripcion;
            txtId.current.setAttribute("disabled", true);
            setHabilitado(true);
            seleccionarPuc();
          } else {
            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe una Cuenta Contable con este Codigo.",
              icono: "informacion",
            });
            // txtDescripcion.current.value = "";
            setActivate(false);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarPlancuenta = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarCuenta(event.target.value);
      } else {
        setValues({
          idplancuenta: "",
          codigocuenta: "",
          descripcion: "",
          idefiscal: "",
          cargable: "",
          naturaleza: "",
          tipopago: "",
          tiporecurso: "",
        });
        // cmbTipo.current.value = "";
        txtCuentaContable.current.value = "";
        // txtDescripcion.current.value = "";
      }
    }
  };
  const onChangeValidar = () => {
    let sigue = true;
    if (!botones.incluir || !botones.modificar) {
      if (txtId.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación",
          texto: "Debe Seleccionar Una cuenta.",
          icono: "informacion",
        });
        sigue = false;
        txtId.current.focus();
      }
    }
    if (sigue) {
      let msg = "";
      if (!botones.incluir) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (!botones.modificar) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (!botones.eliminar) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    }
  };

  const onBotones = (op) => (e) => {
    setOperacion(op);
    if (op === 1 || op === 2 || op === 3 || op === 4) {
      setVisibleBtn("hidden");
    } else if (op === 6) {
      setVisibleBtn("visible");
    }
    e.preventDefault();

    if (op === 1) {
      setVisibleId("hidden");
      setTituloHeader("Incluir Cuentas Contables.");
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoBene: false,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 2) {
      setTituloHeader("Editar Cuentas Contables.");

      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 3) {
      setTituloHeader("Eliminar Cuentas Contables.");

      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 4) {
      setTituloHeader("Consultar Cuentas Contables.");

      setHabilitado(true);
      txtId.current.focus();
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
      txtId.current.removeAttribute("disabled");

      txtId.current.focus();
    } else if (op === 5) {
      onChangeValidar();
    } else if (op === 6) {
      blanquear();
    }
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  const validarItem = (item) => (event) => {
    setActivate2(true);
    let array = [];
    for (let i = 0; i < records.length; i++) {
      let array2 = {};
      let array3 = records2;

      if (item.idpuc === records[i].idpuc) {
        if (records[i].checked === 0) {
          array2 = {
            descripcion: records[i].descripcion,
            idcuentadebe: records[i].idcuentadebe,
            idcuentahaber: records[i].idcuentahaber,
            idcuentahaberorden: records[i].idcuentahaberorden,
            idefiscal: records[i].idefiscal,
            idpuc: records[i].idpuc,
            puc: records[i].puc,
            checked: 1,
          };
          let existe = false; 
          for (let j = 0; j < array3.length; j++) {
            if (array3[j].idpuc === records[i].idpuc) {
              array3[j].checked = 1;
              existe = true;
            }
          }
          if (!existe) {
            array3.push({
              idpuc: records[i].idpuc,
              checked: 1,
            });
          }
          setRecords2(array3);
        } else {
          array2 = {
            descripcion: records[i].descripcion,
            idcuentadebe: records[i].idcuentadebe,
            idcuentahaber: records[i].idcuentahaber,
            idcuentahaberorden: records[i].idcuentahaberorden,
            idefiscal: records[i].idefiscal,
            idpuc: records[i].idpuc,
            puc: records[i].puc,
            checked: 0,
          };

          let existe = false; 
          for (let j = 0; j < array3.length; j++) {
            if (array3[j].idpuc === records[i].idpuc) {
              array3[j].checked = 0;
              existe = true;
            }
          }
          if (!existe) {
            array3.push({
              idpuc: records[i].idpuc,
              checked: 0,
            });
          }
          setRecords2(array3);
        }

        array.push(array2);
      } else {
        array.push(records[i]);
      }
    }
    setRecords(array);
    setActivate2(false);
  };

  return (
    <div className="col-8 m-0 p-2 border rounded">
      <div className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant text-light rounded-top">
        <h3>{tituloHeader}</h3>
        <a type="button" onClick={cerrar} className="text-light fw-bold">
          Salir<i className="fas fa-times ms-2"></i>
        </a>
      </div>

      <fieldset className="col-12 m-0 p-2 d-flex flex-wrap border-azul rounded">
        <legend className="float-none w-auto m-0">Datos de la Cuenta</legend>

        <div className="col-12 m-0 p-0 d-flex">
          <SearchInput
            label="Código:"
            name="idcuentabancaria"
            disabled
            defaultValue={
              values.idplancuenta !== null || values.idplancuenta !== ""
                ? values.idplancuenta.trim()
                : ""
            }
            onKeyUp={validarPlancuenta}
            onBlur={validarPlancuenta}
            onClickButton={() => {
              setMostrar(true);
            }}
            disabledButton={habilitado}
            ref={txtId}
          />
          <Input
            disabled
            id="codigocuenta"
            name="codigocuenta"
            ref={txtCuentaContable}
          />
        </div>
      </fieldset>
      <ul className="nav mt-2 " id="ex-with-icons" role="tablist">
        <li className="nav-item" role="presentation">
          <a
            className="nav-link active bg-blue-100 text-light rounded"
            id="datosTributarios"
            data-bs-toggle="tab"
            type="button"
            data-bs-target="#tributarios"
            role="tab"
            aria-controls="tributarios"
            aria-selected="true"
          >
            Cuentas Presupuestarias
          </a>
        </li>
        <li className="nav-item" role="presentation">
          <a
            className="nav-link bg-blue-200 text-light rounded"
            id="datosTributarios2"
            data-bs-toggle="tab"
            type="button"
            data-bs-target="#tributarios2"
            role="tab"
            aria-controls="tributarios2"
            aria-selected="false"
          >
            Otros Datos
          </a>
        </li>
      </ul>
      <div className="tab-content m-0 mb-2 p-0" id="myTabContent">
        <div
          className="tab-pane fade show active m-0 p-0"
          id="tributarios"
          role="tabpanel"
          aria-labelledby="datosTributarios"
        >
          <div className="col-4 m-0 my-2 p-0">
            <SearchInput
              disabled={operacion === 0 ? true : false}
              placeholder="Buscar"
              onChange={handleSearch}
            />
          </div>
          <div className="col-12 m-0 p-0">
            <TblContainer
              container={{
                height: 200,
                width: "100%",
                overflow: "auto",
                padding: "2px",
              }}
            >
              <TblHead />

              <tbody>
                {records &&
                  recordsAfterPagingAndSorting().map((item, index) => (
                    <tr>
                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={parseInt(item.checked) === 1 ? true : 0}
                          onChange={validarItem(item)}
                        />
                      </td>

                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        {item.puc}
                      </td>

                      <td
                        style={{
                          fontSize: "10px",
                          textAlign: "center",
                        }}
                      >
                        {item.descripcion}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </TblContainer>
          </div>
        </div>
        <div
          className="tab-pane"
          id="tributarios2"
          role="tabpanel"
          aria-labelledby="datosTributarios2"
        ></div>
      </div>
      {visibleBtn === "visible" && (
        <div className="col-12 m-0 p-0 d-flex justify-content-end gap-2">
          <PrimaryButton
            icon="fa-plus"
            disabled={botones.incluir}
            onClick={onBotones(1)}
          >
            Vincular
          </PrimaryButton>
        </div>
      )}

      <div
        className="col-12 m-0 p-0 d-flex justify-content-end gap-2"
        style={{
          visibility: visibleBtn === "visible" ? "collapse" : "visible",
        }}
      >
        <SuccessButton
          disabled={botones.aceptar}
          onClick={onBotones(5)}
          ref={btnAcepta}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          disabled={botones.cancelar}
          onClick={onBotones(6)}
          ref={btnCancela}
        >
          Cancelar
        </DangerButton>
      </div>

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />

      <CatalogoContable
        show={mostrar}
        onHideCancela={() => {
          setMostrar(false);
        }}
        onHideAcepta={seleccionarCuenta}
        llamado={1}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
}
export default TablaVincularCuenta;
